<template>

    <input type="text" :class="classType" :value="modelValue" :placeholder="$attrs.placeholder" :disabled="$attrs.disabled" @input="$emit('update:modelValue', $event.target.value)">

</template>

<script setup>
import {onMounted, ref} from "vue";
import myUtil from "@/util/util";

    const props = defineProps(['modelValue','classType'])
    defineEmits(['update:modelValue'])

const classType = ref("text-input")

onMounted(() => {
  if (myUtil.isNotEmpty(props.classType)){
    classType.value = props.classType
  }
})
</script>

<style scoped>

    .text-input {
        margin-top: 10px;
        margin-bottom: 10px;
        width: 100%;
        height: 35px;
        border-bottom: 1px #888888 solid;
        border-top: 0 #000000 solid;
        border-left: 0 #000000 solid;
        border-right: 0 #000000 solid;
        outline: 0;
    }
    .text-input2 {
      margin-top: 10px;
      margin-bottom: 10px;
      width: 100%;
      height: 50px;
      border-bottom: 0px #888888 solid;
      border-top: 0 #000000 solid;
      border-left: 0 #000000 solid;
      border-right: 0 #000000 solid;
      outline: 0;
      color: #FFFFFF;
      background: transparent;
    }
    .text-input2::placeholder {
      color: #ffffff;
    }
    .text-input2::-webkit-input-placeholder { /* WebKit, Blink, Edge */
      color: #FFFFFF;
    }
    .text-input2:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
      color: #FFFFFF;
      opacity:  1;
    }
    .text-input2::-moz-placeholder { /* Mozilla Firefox 19+ */
      color: #FFFFFF;
      opacity:  1;
    }
    .text-input2:-ms-input-placeholder { /* Internet Explorer 10-11 */
      color: #FFFFFF;
    }
    .text-input2::-ms-input-placeholder { /* Microsoft Edge */
      color: #FFFFFF;
    }

    .text-input2::placeholder { /* Most modern browsers support this now. */
      color: #FFFFFF;
    }

</style>